import { render, staticRenderFns } from "./TicketCalendar.vue?vue&type=template&id=0d979a5c&scoped=true&"
import script from "./TicketCalendar.vue?vue&type=script&lang=js&"
export * from "./TicketCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TicketCalendar.vue?vue&type=style&index=0&id=0d979a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d979a5c",
  null
  
)

export default component.exports